import { CustomCellEditorProps } from "ag-grid-react";
import { ObjectTagValuesAvailableItem } from "../../../../services/object-tag-values-data-service/ConfigurationModels";
import { ObjectTagValuesTagGroupTagConfigurationFieldType } from "../ObjectTagValuesConfigurationFieldTypes";
import { ColDef } from "ag-grid-community";
import { makeSelectedTagEquatableKey } from "../../../../common/utilities/drcx/MakeSelectedTagEquatableKey";
import { ColumnType } from "../../../../common/enums/DRCXEnums";
import { DataTypeEnum } from "../../../../common/enums/DataTypeEnum";
import { parseSelectedTagEquatableKey } from "../../../../common/utilities/drcx/ParseSelectedTagEquatableKey";
import Enumerable from "linq";

export type ObjectTagValuesTagGridRow = {
    equatableKey: string;
    tagName: string;
    tagType: string;
    uom: string;
    eLynxTagGroup: string;
    customTagGroup: string;
    checked: boolean
}

export function createTagGridRows(
    availableTags: Array<ObjectTagValuesAvailableItem> | undefined,
    tagFields: Array<ObjectTagValuesTagGroupTagConfigurationFieldType>,
    assignedGroups: Enumerable.ILookup<string, string> | undefined
): Array<ObjectTagValuesTagGridRow> {

    return availableTags
        ?.map(availableTag => {
            const equatableKey = makeSelectedTagEquatableKey(
                availableTag.tatTypeID ? ColumnType.TatType : ColumnType.Tat,
                availableTag.tatID,
                availableTag.tatTypeID,
                DataTypeEnum.Double
            );
            const columnIndex = tagFields.findIndex(g => g.equatableKey === equatableKey);
            const customTagGroups = assignedGroups?.get(equatableKey).toArray().join(", ") ?? ""

            return {
                equatableKey: equatableKey,
                tagName: availableTag.tagName ?? "",
                tagType: availableTag.tatName ?? "",
                uom: availableTag.tagUomName ?? "",
                eLynxTagGroup: availableTag.eLynxGroupName ?? "",
                customTagGroup: customTagGroups,
                checked: columnIndex > -1,
            };
        }) ?? [];
}

export function createTagGridColumns(
    onCheckboxChange: (item: ObjectTagValuesTagGridRow, checked: boolean) => void
): Array<ColDef> {
    return [{
        headerName: "",
        field: "checked",
        cellRenderer: "checkBoxCellRenderer",
        cellRendererParams: (params: CustomCellEditorProps) => {
            return {
                disabled: false,
                checked: params.value,
                onChange: onCheckboxChange
            };
        },
        suppressHeaderMenuButton: true,
    }, {
        headerName: "Tag Name",
        field: "tagName",
        type: "text"
    }, {
        headerName: "Tag Type",
        field: "tagType",
        type: "text"
    }, {
        headerName: "UoM",
        field: "uom",
        type: "text"
    }, {
        headerName: "eLynx Tag Group",
        field: "eLynxTagGroup",
        type: "text"
    }, {
        headerName: "Custom Tag Group",
        field: "customTagGroup",
        type: "text"
    }];
}

export function createTagField(
    item: ObjectTagValuesTagGridRow
): ObjectTagValuesTagGroupTagConfigurationFieldType {
    const { tatID, tatTypeID } = parseSelectedTagEquatableKey(item.equatableKey);

    return {
        equatableKey: item.equatableKey,
        tatTypeID: tatTypeID,
        tatName: item.tagType,
        tatID: tatID,
        isNew: true
    };
}

export function filterTagGridRows(
    availableTagGridRows: Array<ObjectTagValuesTagGridRow>,
    viewSelected: boolean,
    viewAll: boolean
): Array<ObjectTagValuesTagGridRow> {
    return availableTagGridRows
        ?.filter(item => viewSelected
            ? item.checked
            : viewAll || !!item.tagName
        )
        .sort((a, b) => viewAll
            ? a.tagType.localeCompare(b.tagType)
            : a.tagName.localeCompare(b.tagName)
        );
}